import { api } from '@/features/auth';

export const integrationsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        notifyOnboardingCompleteMake: builder.mutation<void, void>({
            query: () => ({
                url: `accounts/onboarding/make/complete`,
                method: 'POST',
            }),
        }),
    }),
});

export const { useNotifyOnboardingCompleteMakeMutation } = integrationsApi;
